import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';
import Spinner from '../spinner/spinner';
import '../App.css';
import './userHistory.css';
import {
    ChakraProvider, IconButton, Menu, MenuButton, MenuList, MenuItem, SkeletonText, Modal,
    ModalOverlay,
    ModalContent,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button,
} from '@chakra-ui/react';
// import { DeleteIcon } from '@chakra-ui/icons'
import HamburgerIcon from '../assets/three-dot-menu.png'
import { useToast } from '@chakra-ui/react'

const SERVER_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000/' : '/api/';
const HISTORY_SERVER_URL = SERVER_URL + 'history';
const USER_LOGS_SERVER_URL = SERVER_URL + 'user-logs';

export default function UserHistory(props) {
    const OverlayTwo = () => (
        <ModalOverlay
            bg='blackAlpha.300'
            backdropFilter='blur(10px) hue-rotate(90deg)'
        />
    )

    const [selectedChat, setSelectedChat] = useState([]);
    const [isloading, setisloading] = useState(true);
    const [isOpeningChat, setIsOpeningChat] = useState(false);
    const [userHistory, setUserHistory] = useState({});
    const [today, setToday] = useState([]);
    const [yesterday, setYesterday] = useState([]);
    const [last7Days, setLast7Days] = useState([]);
    const [last30Days, setLast30Days] = useState([]);
    const [childData, setChildData] = useState("");
    const [overlay, setOverlay] = React.useState(<OverlayTwo />)
    const { isOpen, onOpen, onClose } = useDisclosure()
    const toast = useToast({ position: 'top-right' })
    const [error, setError] = useState(null); // Handle error state
    // Chat that should become selected once the next regroup runs. Set by
    // childMethod, consumed by the regroup effect below.
    const pendingSelectRef = useRef(null);
    const hasGroupedRef = useRef(false);


    const removeHistory = (chatId) => {
        setUserHistory((prevHistory) => {
            const updatedHistory = { ...prevHistory };

            // Remove the entry with the matching chatId
            if (updatedHistory[chatId]) {
                delete updatedHistory[chatId];
            }
            return updatedHistory; // Return the updated history object
        });
    };

    const handleSubmit = async () => {
        if (!selectedChat?.[0]?.["ChatId"]) {
            return;
        }
        const deleteChatPromise = new Promise(async (resolve, reject) => {
            const response = await axios.delete(HISTORY_SERVER_URL, {
                params: { ChatId: selectedChat[0]["ChatId"] }  // Replace with dynamic email if needed
            });
            if (response.data.valid) {
                removeHistory(selectedChat[0]["ChatId"])
                props.handleNewChat();
                resolve('Chat Deleted successfully');
            } else {
                reject('Failed to Delete Chat history!');
                console.error("Failed to Delete Chat history:", response.data.message);
            }
        })
        toast.promise(deleteChatPromise, {
            loading: {
                title: props.translate('Deleting Chat'), description: props.translate('Please wait') + '...', duration: 1000, isClosable: true
            },
            success: { description: props.translate('Chat Deleted successfully!'), duration: 1000, isClosable: true, },
            error: { description: props.translate('Something went wrong. Please try again.'), duration: 1000, isClosable: true, },
        });
        try {
            await deleteChatPromise;
            onClose(); // Close modal
        } catch (error) {
            setError(error); // Set error state if submission fails
        }
    }
    // Method in the child to be called from the parent
    const childMethod = (data) => {
        setChildData(data);
        // The updater must stay PURE. It used to call groupingFunction (which
        // calls setToday/setSelectedChat/...) from in here; React StrictMode
        // re-invokes updaters during render, which turned those into
        // render-phase updates that never converge — "Too many re-renders",
        // blanking the app the moment an answer was saved to history. Dev-only
        // because a production build evaluates the updater eagerly in the
        // event handler instead. Regrouping now happens in the effect below.
        pendingSelectRef.current = data;
        setUserHistory((prevHistory) => (
            prevHistory[data.ChatId]
                ? {
                    ...prevHistory,
                    [data.ChatId]: [...prevHistory[data.ChatId], data]
                }
                : {
                    ...prevHistory,
                    [data.ChatId]: [data]
                }
        ));
    };

    // Single place where the grouped/bucketed view is rebuilt, driven by state
    // rather than by whoever happened to mutate userHistory.
    useEffect(() => {
        if (!hasGroupedRef.current && Object.keys(userHistory).length === 0) {
            return; // nothing loaded yet — leave the skeleton alone
        }
        hasGroupedRef.current = true;
        const pending = pendingSelectRef.current;
        pendingSelectRef.current = null;
        groupingFunction(userHistory, pending);
        // groupingFunction is recreated every render but is stable in behaviour;
        // re-running on every render would loop, so key only on the data.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userHistory]);

    const setChat = () => {
        setSelectedChat([]);
    }
    useEffect(() => {
        if (props.setChildFunc) {
            // Pass the childMethod to the parent
            props.setChildFunc(() => childMethod); // Use a stable function reference
        }
    }, [props.setChildFunc]);

    useEffect(() => {
        if (props.setRemoveChatFunc) {
            // Pass the childMethod to the parent
            props.setRemoveChatFunc(() => setChat); // Use a stable function reference
        }
    }, [props.setRemoveChatFunc]);


    useEffect(() => {
    }, [today]);


    const getDaysDifference = (date) => {
        const now = new Date();

        // Reset the time part (hours, minutes, seconds, and milliseconds) for both dates
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const targetDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

        // Calculate the difference in days between the two dates
        return Math.floor((today - targetDate) / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
    };



    const groupingFunction = (data, newChat) => {
        const lastTimeOf = (entries) => {
            // An unparseable timestamp must not poison the comparator — a NaN
            // comparison silently leaves the list in arbitrary order.
            const value = new Date(entries?.[entries.length - 1]?.Timestamp).getTime();
            return Number.isNaN(value) ? 0 : value;
        };
        const sortedData = Object.entries(data)
            .filter(([, entries]) => Array.isArray(entries) && entries.length > 0)
            .sort(([, timestampsA], [, timestampsB]) => (
                // Descending by the latest timestamp in each group
                lastTimeOf(timestampsB) - lastTimeOf(timestampsA)
            ))
            .reduce((acc, [key, value]) => {
                acc[key] = value;
                return acc;
            }, {});
        const categorizedData = {
            today: [],
            yesterday: [],
            last7Days: [],
            last30Days: []
        };
        Object.entries(sortedData).forEach(([key, timestamps]) => {
            // Get the latest timestamp in each group
            const lastTimestamp = new Date(timestamps[timestamps.length - 1].Timestamp);

            // Calculate days difference
            const daysDifference = getDaysDifference(lastTimestamp);

            // Categorize the entry based on the days difference
            if (daysDifference === 0) {
                categorizedData.today.push({ [key]: timestamps });
            } else if (daysDifference === 1) {
                categorizedData.yesterday.push({ [key]: timestamps });
            } else if (daysDifference <= 7) {
                categorizedData.last7Days.push({ [key]: timestamps });
            } else if (daysDifference <= 30) {
                categorizedData.last30Days.push({ [key]: timestamps });
            }
        });
        setToday(categorizedData.today);
        setYesterday(categorizedData.yesterday);
        setLast7Days(categorizedData.last7Days);
        setLast30Days(categorizedData.last30Days);
        if (newChat?.ChatId) {
            // Was categorizedData.today[0][newChat.ChatId] — it assumed the new
            // chat always sorts first. When it did not (or today was empty) this
            // threw, or set selectedChat to undefined and crashed the render.
            const bucket = categorizedData.today.find((group) => group[newChat.ChatId]);
            if (bucket) {
                setSelectedChat(bucket[newChat.ChatId]);
            }
        }
    }

    useEffect(() => {

        const fetchUserEmail = async () => {
            if (process.env.NODE_ENV === 'development') {
                const devEmail = sessionStorage.getItem('userinfo') || 'dev@local.com';
                sessionStorage.setItem('userinfo', devEmail);
                return;
            }
            try {
                setisloading(true);
                const response = await axios.get("/oauth2/userinfo")
                if (response.data?.preferredUsername) {
                    sessionStorage.setItem("userinfo", response.data.preferredUsername.toLowerCase())
                    let body = { "UserEmail": response.data.preferredUsername.toLowerCase() }
                    const userLog = await axios.post(USER_LOGS_SERVER_URL, body)
                } else {
                    sessionStorage.setItem("userinfo", response.data.user.toLowerCase())
                    let body = { "UserEmail": response.data.user.toLowerCase() }
                    const userLog = await axios.post(USER_LOGS_SERVER_URL, body)
                }
            } catch (err) {
                console.log(err)
            }
        }

        const fetchUserHistory = async () => {
            try {
                setisloading(true);
                if (!sessionStorage.getItem('userinfo')) {
                    await fetchUserEmail();
                }
                const response = await axios.get(HISTORY_SERVER_URL);
                if (response.data.valid) {
                    // The regroup effect picks this up — do not group here too.
                    setUserHistory(response.data.response);
                    setisloading(false);
                } else {
                    console.error("Failed to fetch user history:", response.data.message);
                    setisloading(false);
                }
            } catch (error) {
                setisloading(false);
                console.error("Error fetching user history:", error);
            }
        };
        fetchUserHistory(); // Call the function
    }, []); // Empty dependency array means this runs once on mount

    const handleClick = async (sidebarEntries) => {
        // The sidebar list holds titles only; the answers and pages load here.
        let userHistoryEntries = sidebarEntries;
        setIsOpeningChat(true);
        try {
            const response = await axios.get(`${HISTORY_SERVER_URL}/chat`, {
                params: { ChatId: sidebarEntries[0]?.ChatId },
            });
            if (response.data.valid) {
                userHistoryEntries = response.data.response;
            }
        } catch (error) {
            console.error("Error fetching chat:", error);
        } finally {
            setIsOpeningChat(false);
        }
        userHistoryEntries.forEach((entry) => {
            let assistantResponseObject;
            try {
                assistantResponseObject = typeof entry.AssistantResponse === 'string'
                    ? JSON.parse(entry.AssistantResponse)
                    : entry.AssistantResponse;
            } catch (parseError) {
                // A truncated/legacy row must not take the whole sidebar down.
                console.error('Error parsing AssistantResponse:', parseError);
                assistantResponseObject = { response: entry.AssistantResponse };
            }
            if (!assistantResponseObject || typeof assistantResponseObject !== 'object') {
                assistantResponseObject = { response: assistantResponseObject ?? '' };
            }

            if (entry.images && entry.images.length > 0) {
                assistantResponseObject.images = entry.images;
            }
            if (entry.manuals && entry.manuals.length > 0) {
                assistantResponseObject.manuals = entry.manuals;
            }
            entry.AssistantResponse = assistantResponseObject
        });
        setSelectedChat(userHistoryEntries);
        props.openHistory(userHistoryEntries)
        const lastEntry = userHistoryEntries[userHistoryEntries.length - 1];
        if(lastEntry?.conversation_id) {
            props.setConversationId(lastEntry.conversation_id);
        }
    }

    return (
        <div className="history-container">
            {/* In a portal: the sidebar must not decide what "center of the screen" is. */}
            {isOpeningChat && createPortal(
                <div className="chat-opening-overlay" role="status" aria-label={props.translate("loading")}>
                    <Spinner />
                </div>,
                document.body
            )}
            {!isloading &&
                <>
                    <ChakraProvider resetCSS={false}>
                        <Modal isCentered isOpen={isOpen} onClose={onClose}>
                            {overlay}
                            <ModalContent className="delete-confirmation-modal">
                                <ModalCloseButton />
                                <ModalBody>
                                    <h2 className="feedback-title">{props.translate("Are you sure you want to delete this chat?")}</h2>
                                </ModalBody>
                                <ModalFooter className="delete-confirmation-actions">
                                    <Button className="delete-confirmation-button" onClick={onClose}>
                                        {props.translate('Close')}
                                    </Button>
                                    <Button className="delete-confirmation-button" colorScheme='red' onClick={() => handleSubmit()}>
                                        {props.translate('Delete')}
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </Modal>
                    </ChakraProvider>
                    {today.length > 0 &&
                        <>
                            <h2 className="history-heading">{props.translate("Today")}</h2>
                            <ul className="history-list">
                                {today.map((item, index) => (
                                    item && Object.keys(item).map((key) => (
                                        <li className={`${selectedChat?.length && selectedChat[0]?.["ChatId"] === key ? "selected" : ""}`} key={key} onClick={() => handleClick(item[key])} >
                                            <span className="chat-text">
                                                {item[key] && item[key].length > 0 ? item[key][0].UserResponse : ''}
                                            </span>
                                            <div className="chatOptions">
                                                <ChakraProvider resetCSS={false}>
                                                    <Menu>
                                                        <MenuButton
                                                            as={IconButton}
                                                            aria-label='Options'
                                                            variant='outline'
                                                        ><img className="customMenuIcon" src={HamburgerIcon} alt="menu"></img></MenuButton>
                                                        <MenuList>
                                                            <MenuItem onClick={() => {
                                                                setOverlay(<OverlayTwo />)
                                                                onOpen()
                                                            }}><img className="customDeleteIcon" src="./delete.png" alt="deleteIcon"></img> {props.translate("Delete")}</MenuItem>
                                                        </MenuList>
                                                    </Menu>
                                                </ChakraProvider>
                                            </div>
                                        </li>
                                    ))
                                ))}
                            </ul>
                        </>
                    }
                    {yesterday.length > 0 &&
                        <>
                            <h2 className="history-heading">{props.translate("Yesterday")}</h2>
                            <ul className="history-list">
                                {yesterday.map((item, index) => (
                                    item && Object.keys(item).map((key) => (
                                        <li className={`${selectedChat?.length && selectedChat[0]?.["ChatId"] === key ? "selected" : ""}`} key={key} onClick={() => handleClick(item[key])} >
                                            <span className="chat-text">
                                                {item[key] && item[key].length > 0 ? item[key][0].UserResponse : ''}
                                            </span>
                                            <ChakraProvider resetCSS={false}>
                                                <Menu>
                                                    <MenuButton
                                                        as={IconButton}
                                                        aria-label='Options'
                                                        variant='outline'
                                                    ><img className="customMenuIcon" src={HamburgerIcon} alt="menu"></img></MenuButton>
                                                    <MenuList>
                                                        <MenuItem onClick={() => {
                                                            setOverlay(<OverlayTwo />);
                                                            onOpen();
                                                        }}><img className="customDeleteIcon" src="./delete.png" alt="deleteIcon"></img> {props.translate("Delete")}</MenuItem>
                                                    </MenuList>
                                                </Menu>
                                            </ChakraProvider>
                                        </li>
                                    ))
                                ))}
                            </ul>
                        </>
                    }
                    {last7Days.length > 0 &&
                        <>
                            <h2 className="history-heading">{props.translate("Last 7 Days")}</h2>
                            <ul className="history-list">
                                {last7Days.map((item, index) => (
                                    item && Object.keys(item).map((key) => (
                                        <li className={`${selectedChat?.length && selectedChat[0]?.["ChatId"] === key ? "selected" : ""}`} key={key} onClick={() => handleClick(item[key])} >
                                            <span className="chat-text">
                                                {item[key] && item[key].length > 0 ? item[key][0].UserResponse : ''}
                                            </span>
                                            <ChakraProvider resetCSS={false}>
                                                <Menu>
                                                    <MenuButton
                                                        as={IconButton}
                                                        aria-label='Options'
                                                        variant='outline'
                                                    ><img className="customMenuIcon" src={HamburgerIcon} alt="menu"></img></MenuButton>
                                                    <MenuList>
                                                        <MenuItem onClick={() => {
                                                            setOverlay(<OverlayTwo />);
                                                            onOpen();
                                                        }}><img className="customDeleteIcon" src="./delete.png" alt="deleteIcon"></img> {props.translate("Delete")}</MenuItem>
                                                    </MenuList>
                                                </Menu>
                                            </ChakraProvider>
                                        </li>
                                    ))
                                ))}
                            </ul>
                        </>
                    }
                    {last30Days.length > 0 &&
                        <>
                            <h2 className="history-heading">{props.translate("Last 30 Days")}</h2>
                            <ul className="history-list">
                                {last30Days.map((item, index) => (
                                    item && Object.keys(item).map((key) => (
                                        <li className={`${selectedChat?.length && selectedChat[0]?.["ChatId"] === key ? "selected" : ""}`} key={key} onClick={() => handleClick(item[key])} >
                                            <span className="chat-text">
                                                {item[key] && item[key].length > 0 ? item[key][0].UserResponse : ''}
                                            </span>
                                            <ChakraProvider resetCSS={false}>
                                                <Menu>
                                                    <MenuButton
                                                        as={IconButton}
                                                        aria-label='Options'
                                                        variant='outline'
                                                    ><img className="customMenuIcon" src={HamburgerIcon} alt="menu"></img></MenuButton>
                                                    <MenuList>
                                                        <MenuItem onClick={() => {
                                                            setOverlay(<OverlayTwo />);
                                                            onOpen();
                                                        }}><img className="customDeleteIcon" src="./delete.png" alt="deleteIcon"></img> {props.translate("Delete")}</MenuItem>
                                                    </MenuList>
                                                </Menu>
                                            </ChakraProvider>
                                        </li>
                                    ))
                                ))}
                            </ul>
                        </>
                    }
                </>
            }
            {isloading &&
                <ChakraProvider resetCSS={false}>
                    <ul className="history-list" style={{ paddingInline: "8px" }}>
                        <SkeletonText noOfLines={3} skeletonHeight='3' />
                    </ul>
                </ChakraProvider>
            }
        </div>
    );
}
